module.exports = __webpack_public_path__ + "static/img/p2_2.d3256e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/product/p2_2.png
// module id = hbYc
// module chunks = 1